import { HttpStatusCode } from '@angular/common/http';

import { createAction, props, union } from '@ngrx/store';

import { PricingResponse } from '@cdba/shared/models/responses';

export const loadPricing = createAction('[Detail] Load Pricing');

export const loadPricingSuccess = createAction(
  '[Detail] Load Pricing Success',
  props<{
    response: PricingResponse;
  }>()
);

export const loadPricingFailure = createAction(
  '[Detail] Load Pricing Failure',
  props<{ errorMessage: string; statusCode: HttpStatusCode }>()
);

const all = union({
  loadPricing,
  loadPricingSuccess,
  loadPricingFailure,
});

export type PricingActions = typeof all;
